import { Gallery } from 'react-gesture-gallery';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface ImageProps {
  marginRigth: boolean;
}

export const StyledGallery = styled(Gallery)`
  position: unset !important;
  width: unset !important;
  height: unset !important;

  .Gesture-view__pane {
  }

  .Gallery__NavigationArrow {
    visibility: hidden;
  }

  .Gallery__Indicators {
    visibility: hidden;
    /* margin-top: 32px;
    position: relative; */
  }
`;

export const Container = styled.div`
  display: flex;
  min-height: 100vh;
  background: ${({ theme }) => theme.walkThrough.background};
`;

export const AnimationContainer = styled.div`
  position: sticky;
  overflow-x: hidden;
  overflow-y: scroll;
  width: 100%;
  flex: 1;

  & > div {
    position: absolute;
    width: 100vw;
    height: 100%;
    will-change: transform;

    & > div {
      width: 100%;
      height: 100%;
      will-change: transform;
    }
  }

  @media (min-width: 380px) {
    height: 82%;
  }
`;

export const AnimationContainerDesktop = styled.div`
  position: sticky;
  overflow-x: hidden;
  overflow-y: hidden;

  & > div {
    /* position: absolute; */
    width: 100vw;
    height: 100%;
    will-change: transform;

    & > div {
      width: 100%;
      height: 100%;
      will-change: transform;
    }
  }
`;

export const StepContainer: any = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  margin: auto;
`;

StepContainer.Step = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 5vh;
`;

StepContainer.Logo = styled.img`
  height: 74px;
`;

StepContainer.Header = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

StepContainer.IconArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 144px;
  height: 74px;
  background-size: 100%;
`;

interface IconProps {
  marginLeft: boolean;
}

StepContainer.IconArea.Icon = styled.img<IconProps>`
  margin-left: ${(props: IconProps) => (props.marginLeft ? '14%' : 'unset')};
`;

StepContainer.TextArea = styled.div`
  text-align: center;
  max-width: 80%;
  margin-top: 1vh;

  & > h4 {
    font-weight: bold;
    color: ${({ theme }) => theme.walkThrough.color};
  }

  & > h5 {
    margin-top: 30px;
    line-height: 24px;
    color: ${({ theme }) => theme.walkThrough.color};
    & > strong {
      font-weight: bold;
    }
  }
`;

export const ContainerDesktop = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
  padding-left: 64px;
  background-image: url('/corporate/images/onboarding/oval-rigth-desktop.svg');
  background-position: right;
  background-repeat: no-repeat;
`;

export const Steps = styled.ul`
  display: flex;
`;

interface CircleStyledProps {
  styledProps: {
    active: boolean;
  };
}

export const Circle = styled.li.attrs<HTMLLIElement>((): any => {})<CircleStyledProps>`
  width: 8px;
  height: 8px;
  cursor: pointer;
  border-radius: 4px;
  margin: 0 13px;
  background: ${({ styledProps, theme }) =>
    styledProps.active ? theme.stepper.activeBackground : theme.stepper.background};

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const ButtonDesktopContainer = styled.div`
  padding-bottom: 100px;
  margin-top: 99px;
  max-width: 343px;
`;

export const StepContainerDesktop: any = styled.div`
  display: flex;
  flex-direction: row;
  margin: 190px 0 48px 0;
  align-items: center;
`;

export const IconArea: any = styled.div`
  padding-top: 50px;
  display: flex;
`;

IconArea.Logo = styled.img`
  width: 144px;
  height: 74px;
`;

StepContainerDesktop.TextArea = styled.div`
  user-select: none;
  max-width: 582px;
  & > h5 {
    font-family: Poppins;
    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: -0.2px;
    color: ${ColorPalette.HEX.CharlestonGreen};
    & > strong {
      font-weight: bold;
    }
  }
`;

StepContainerDesktop.Image = styled.div<ImageProps>`
  display: flex;
  height: 270px;
  flex: 1;
  flex-direction: row-reverse;

  & > img {
    margin-right: ${(props: ImageProps) => (props.marginRigth ? '611px' : '401px')};
    height: 100%;
    max-width: 410px;
  }
`;
